module.exports = __webpack_public_path__ + "img/pole.eec13538.webp";